import { gql } from '@edreamsodigeo/frontend-api-client';

export const GET_USER_ACCOUNT = gql`
  query GetUserAccountForCabinBags($userAccountRequest: UserAccountRequest) {
    userAccount(userAccountRequest: $userAccountRequest) {
      isLoggedIn
      userMembership {
        isActive
      }
    }
  }
`;

export const GET_PRIME_SITE_PROPERTIES = gql`
  query PrimeSitePropertiesQueryForCabinBags @ignore_update {
    primeSiteProperties {
      activePrimeMarket {
        flights
        dynpack
      }
    }
  }
`;
